/*
 * Types das acoes de login.
 *
 * @flow
 */
import { http } from "../../../core/Api";
import IO from "../../../core/socket";
import type { ThunkAction } from "../../../types";
import { Toast } from "biologiatotal-ui";

type LoginReqAction = { type: "ACCOUNT/LOGIN_REQUEST" };
type LoginReqSuccessAction = { type: "ACCOUNT/LOGIN_SUCCESS", data: Object };
type LoginReqFailureAction = { type: "ACCOUNT/LOGIN_FAILURE", data: Object };
type LoginReqErrorAction = { type: "ACCOUNT/LOGIN_ERROR", data: Object };
type RegisterReqAction = { type: "ACCOUNT/REGISTER_REQUEST" };
type RegisterReqSuccessAction = {
  type: "ACCOUNT/REGISTER_SUCCESS",
  data: Object
};
type RegisterReqFailureAction = {
  type: "ACCOUNT/REGISTER_FAILURE",
  data: Object
};
type RegisterReqErrorAction = { type: "ACCOUNT/REGISTER_ERROR", data: Object };

type PlansReqAction = { type: "ACCOUNT/PLANS_REQUEST" };
type PlansReqSuccessAction = { type: "ACCOUNT/PLANS_SUCCESS", data: Object };
type PlansReqErrorAction = { type: "ACCOUNT/PLANS_ERROR", data: Object };

type ApplyCouponReqAction = { type: "ACCOUNT/APPLY_COUPON_REQUEST" };
type ApplyCouponReqSuccessAction = {
  type: "ACCOUNT/APPLY_COUPON_SUCCESS",
  data: Object
};
type ApplyCouponReqFailureAction = {
  type: "ACCOUNT/APPLY_COUPON_FAILURE",
  data: Object
};

type InstallmentsReqAction = {
  type: "ACCOUNT/INSTALLMENTS_REQUEST",
  plan: string,
  coupon: ?string
};
type InstallmentsReqSuccessAction = {
  type: "ACCOUNT/INSTALLMENTS_SUCCESS",
  data: Object
};
type InstallmentsReqFailureAction = {
  type: "ACCOUNT/INSTALLMENTS_FAILURE",
  data: Object
};

type CouponCodeChange = { type: "ACCOUNT/COUPON_CODE_CHANGE", data: string };
type CouponClear = { type: "ACCOUNT/CLEAR_COUPON" };

type SelectPlan = { type: "ACCOUNT/SELECT_PLAN", data: Object };

type PayReqAction = { type: "ACCOUNT/PAY_REQUEST" };
type PayReqSuccessAction = { type: "ACCOUNT/PAY_SUCCESS", data: Object };
type PayReqFailureAction = { type: "ACCOUNT/PAY_FAILURE", data: Object };
type PayReqErrorAction = { type: "ACCOUNT/PAY_ERROR", data: Object };

type RegisterSocketAction = { type: "ACCOUNT/REGISTER_SOCKET", data: string };
type TransactionUpdateAction = {
  type: "ACCOUNT/TRANSACTION_UPDATE",
  data: Object
};

type RecoveryReqAction = { type: "ACCOUNT/RECOVER_REQUEST" };
type RecoveryReqSuccessAction = { type: "ACCOUNT/RECOVER_SUCCESS", data: Object };
type RecoveryReqFailureAction = { type: "ACCOUNT/RECOVER_FAILURE", data: Object };

type CepReqAction = { type: "ACCOUNT/CEP_REQUEST" };
type CepReqSuccessAction = {
  type: "ACCOUNT/CEP_SUCCESS",
  data: Object
};
type CepReqErrorAction = {
  type: "ACCOUNT/CEP_ERROR",
  data: Object
};

export type AccountAction =
  | RecoveryReqAction
  | RecoveryReqSuccessAction
  | RecoveryReqFailureAction
  | InstallmentsReqAction
  | InstallmentsReqSuccessAction
  | InstallmentsReqFailureAction
  | LoginReqAction
  | LoginReqSuccessAction
  | LoginReqFailureAction
  | LoginReqErrorAction
  | RegisterReqAction
  | RegisterReqSuccessAction
  | RegisterReqErrorAction
  | RegisterReqFailureAction
  | PlansReqAction
  | PlansReqSuccessAction
  | PlansReqErrorAction
  | ApplyCouponReqAction
  | ApplyCouponReqSuccessAction
  | ApplyCouponReqFailureAction
  | SelectPlan
  | CouponCodeChange
  | CouponClear
  | PayReqErrorAction
  | PayReqFailureAction
  | PayReqSuccessAction
  | PayReqAction
  | RegisterSocketAction
  | TransactionUpdateAction
  | CepReqAction
  | CepReqSuccessAction
  | CepReqErrorAction;

export function transactionUpdate(data: Object): AccountAction {
  return {
    type: "ACCOUNT/TRANSACTION_UPDATE",
    data
  };
}

export function registerSocket(id: string): AccountAction {
  return {
    type: "ACCOUNT/REGISTER_SOCKET",
    data: id
  };
}

export function payRequest(values: Object): AccountAction {
  return {
    type: "ACCOUNT/PAY_REQUEST",
    data: values
  };
}

export function payRequestSuccess(response: Object): AccountAction {
  return {
    type: "ACCOUNT/PAY_SUCCESS",
    data: response
  };
}
export function payRequestFailure(error: Object): AccountAction {
  return {
    type: "ACCOUNT/PAY_FAILURE",
    data: error
  };
}

export function payRequestError(error: Object): AccountAction {
  return {
    type: "ACCOUNT/PAY_ERROR",
    data: error
  };
}

export function couponClear(clearInput = true): AccountAction {
  return {
    type: "ACCOUNT/CLEAR_COUPON",
    clearInput
  };
}

export function couponCodeChange(code: string): AccountAction {
  return {
    type: "ACCOUNT/COUPON_CODE_CHANGE",
    data: code
  };
}

export function selectPlan(plan: Object): AccountAction {
  return {
    type: "ACCOUNT/SELECT_PLAN",
    data: plan
  };
}

export function applyCouponRequest(): AccountAction {
  return {
    type: "ACCOUNT/APPLY_COUPON_REQUEST"
  };
}

export function applyCouponSuccess(data: Object): AccountAction {
  return {
    type: "ACCOUNT/APPLY_COUPON_SUCCESS",
    data
  };
}

export function applyCouponFailure(data: Object): AccountAction {
  return {
    type: "ACCOUNT/APPLY_COUPON_FAILURE",
    data
  };
}

export function plansRequest(): AccountAction {
  return {
    type: "ACCOUNT/PLANS_REQUEST"
  };
}

export function plansRequestSuccess(data: Object): AccountAction {
  return {
    type: "ACCOUNT/PLANS_SUCCESS",
    data
  };
}

export function plansRequestError(data: Object): AccountAction {
  return {
    type: "ACCOUNT/PLANS_ERROR",
    data
  };
}

export function registerRequest(): AccountAction {
  return {
    type: "ACCOUNT/REGISTER_REQUEST"
  };
}

export function registerRequestSuccess(data: Object): AccountAction {
  return {
    type: "ACCOUNT/REGISTER_SUCCESS",
    data
  };
}

export function registerRequestFailure(data: Object): AccountAction {
  return {
    type: "ACCOUNT/REGISTER_FAILURE",
    data
  };
}

export function registerRequestError(data: Object): AccountAction {
  return {
    type: "ACCOUNT/REGISTER_ERROR",
    data
  };
}

export function loginRequest(): AccountAction {
  return {
    type: "ACCOUNT/LOGIN_REQUEST"
  };
}

export function loginRequestSuccess(data: Object): AccountAction {
  return {
    type: "ACCOUNT/LOGIN_SUCCESS",
    data
  };
}

export function loginRequestFailure(data: Object): AccountAction {
  return {
    type: "ACCOUNT/LOGIN_FAILURE",
    data
  };
}

export function recoverRequest(): AccountAction {
  return {
    type: "ACCOUNT/RECOVER_REQUEST"
  };
}

export function recoverRequestSuccess(data: Object): AccountAction {
  return {
    type: "ACCOUNT/RECOVER_SUCCESS",
    data
  };
}

export function recoverRequestFailure(data: Object): AccountAction {
  return {
    type: "ACCOUNT/RECOVER_FAILURE",
    data
  };
}

export function loginRequestError(data: Object): AccountAction {
  return {
    type: "ACCOUNT/LOGIN_ERROR",
    data
  };
}

export function installmentsRequest(plan: string, coupon: ?string): AccountAction {
  return {
    type: "ACCOUNT/INSTALLMENTS_REQUEST",
    plan,
    coupon
  };
}

export function installmentsSuccess(data: Object): AccountAction {
  return {
    type: "ACCOUNT/INSTALLMENTS_SUCCESS",
    data
  };
}

export function installmentsFailure(data: Object): AccountAction {
  return {
    type: "ACCOUNT/INSTALLMENTS_FAILURE",
    data
  };
}

export function cleanDetails() {
  return {
    type: "ACCOUNT/CLEAN_DETAILS"
  };
}

export function cepRequest(): CepReqAction {
  return {
    type: "ACCOUNT/CEP_REQUEST"
  };
}

export function cepRequestSuccess(data: Object): CepReqSuccessAction {
  return {
    type: "ACCOUNT/CEP_SUCCESS",
    data
  };
}

export function cepRequestError(data: Object): CepReqErrorAction {
  return {
    type: "ACCOUNT/CEP_ERROR",
    data
  };
}

export function doLoginRequest(form: Object): ThunkAction {
  return dispatch => {
    dispatch(loginRequest());
    const formWithExtra = {
      ...form,
      application: "web"
    };
    return http("api/backend/v2/admin/auth/login", "POST", formWithExtra)
      .then(response => {
        if (response.ok === false) {
          throw Error(response.status);
        }

        if (response.access_token && response.access_token !== "undefined" && response.access_token !== "Undefined") {
          localStorage.setItem("bt:accessTokenAdmin", response.access_token);
          return dispatch(loginRequestSuccess(response));
        } else {
          return dispatch(loginRequestError("Login sem token valido"));
        }
      })
      .catch(err => {
        if (err.message === "401") {
          dispatch(loginRequestFailure(err));
          return Promise.reject(err.message);
        }
        dispatch(loginRequestError(err));
        return Promise.reject(err.message);
      });
  };
}

export function doRecoverRequest(email) {
  return dispatch => {
    dispatch(recoverRequest());
    return http("api/backend/v2/user/forgout", "POST", { email: email })
      .then(response => {
        if (response.error) {
          return dispatch(recoverRequestFailure(response.error));
        }
        // response = { send: true }
        return dispatch(recoverRequestSuccess(response));
      })
      .catch(err => {
        console.log(err);
      });
  };
}

export function doRegisterRequest(form: Object): ThunkAction {
  return dispatch => {
    dispatch(registerRequest());
    const formWithExtra = {
      ...form
    };
    return http("api/backend/v2/user", "POST", formWithExtra)
      .then(response => {
        if (response.ok === false) {
          throw Error(response.status);
        }
        return dispatch(registerRequestSuccess(response));
      })
      .catch(err => {
        if (err.message === "401") {
          dispatch(registerRequestFailure(err));
          return Promise.reject(err.message);
        }
        dispatch(registerRequestError(err));
        return Promise.reject(err.message);
      });
  };
}

export function doPlansRequest(): ThunkAction {
  return dispatch => {
    dispatch(plansRequest());
    return http("api/backend/v2/plans", "GET")
      .then(response => {
        if (response.ok === false) {
          throw Error(response.status);
        }
        return dispatch(plansRequestSuccess(response));
      })
      .catch(err => {
        dispatch(plansRequestError(err));
        return Promise.reject(err.message);
      });
  };
}

export function doSelectPlan(plan: Object): ThunkAction {
  return (dispatch, getState) => {
    dispatch(selectPlan(plan));

    if (plan && plan.id) {
      const { coupon } = getState().account.data;
      let couponId = coupon ? coupon.coupon.id : "";

      if (coupon && coupon.plan.id !== plan.id) {
        couponId = "";
      }

      return dispatch(doInstallmentsRequest(plan.id, couponId));
    }
  };
}

export function doInstallmentsRequest(plan: string, coupon: string): ThunkAction {
  return dispatch => {
    dispatch(installmentsRequest(plan, coupon));

    return http(`api/backend/v2/payments/card/installments?plan=${plan}&coupon=${coupon}`, "GET")
      .then(response => {
        if (response.ok === false) {
          throw Error(response.status);
        }
        return dispatch(installmentsSuccess(response));
      })
      .catch(err => {
        dispatch(installmentsFailure(err));
        return Promise.reject(err.message);
      });
  };
}

export function doApplyCoupon(coupon: string): ThunkAction {
  return (dispatch, getState) => {
    dispatch(applyCouponRequest());
    return http(`api/backend/v2/coupons/${(coupon || "").toUpperCase()}`, "GET")
      .then(response => {
        if (response.ok === false) {
          throw Error(response.status);
        }

        dispatch(applyCouponSuccess(response));

        const { data } = getState().account;
        if (data.selectedPlan && data.selectedPlan.id === response.plan.id) {
          return dispatch(doInstallmentsRequest(response.plan.id, response.coupon.id));
        }

        return Promise.reject({ message: 999 });
      })
      .catch(err => {
        dispatch(applyCouponFailure(err));
        return Promise.reject(err.message);
      });
  };
}

export function doPay(values: Object, type: string, subscription): ThunkAction {
  return dispatch => {
    dispatch(payRequest(values));

    const operation = values.recurrence ? "subscription" : "transaction";

    return http(`api/backend/v2/payments/${type}/${operation}`, "POST", values)
      .then(response => {
        if (response.ok === false) {
          if (response.status === 422) {
            return response.json().then(body => {
              Toast.error(body.message);
              throw Error(response.status);
            });
          }

          throw Error(response.status);
        }

        //dispatch(doRegisterTransaction(String(response.pagarme_id)));
        return dispatch(payRequestSuccess(response));
      })
      .catch(err => {
        if (err.message === "401") {
          dispatch(payRequestFailure(err));
          return Promise.reject(err.message);
        }

        dispatch(payRequestError(err));
        return Promise.reject(err.message);
      });
  };
}

export function doPayCouponFree(values: Object): ThunkAction {
  return dispatch => {
    dispatch(payRequest(values));

    return http(`api/backend/v2/payments/coupon`, "POST", values)
      .then(response => {
        if (response.ok === false) {
          throw Error(response.status);
        }

        //dispatch(doRegisterTransaction(String(response.pagarme_id)));
        return dispatch(payRequestSuccess(response));
      })
      .catch(err => {
        if (err.message === "401") {
          dispatch(payRequestFailure(err));
          return Promise.reject(err.message);
        }
        dispatch(payRequestError(err));
        return Promise.reject(err.message);
      });
  };
}

export function doRegisterTransaction(pagarmeid: string): ThunkAction {
  return dispatch => {
    dispatch(registerSocket(pagarmeid));

    const io = new IO();
    io.sockets.payment.on(`transaction${pagarmeid}`, function(msg) {
      dispatch(transactionUpdate(msg));
    });
  };
}

export function doCepRequest(cep: string): ThunkAction {
  return dispatch => {
    dispatch(cepRequest());

    return fetch(`https://viacep.com.br/ws/${cep}/json/`, { method: "GET" }).then(response =>
      response.json().then(json => {
        if (json.erro) {
          return Promise.reject(dispatch(cepRequestError("CEP Inválido")));
        }
        return dispatch(cepRequestSuccess(json));
      })
    );
  };
}
